// extracted by mini-css-extract-plugin
module.exports = {"Info":"Info_Info__20X-V","InfoCenter":"Info_InfoCenter__1mD-C","map":"Info_map__2XBCe","P":"Info_P__2prpW","H2":"Info_H2__2f0VC","H3":"Info_H3__3kIzD"};